import React from 'react'

const DoubleQuote = (props) => {
  return (
    <>
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={150}
    aria-hidden="true"
    className="iconify iconify--emojione-monotone"
    viewBox="0 0 64 64"
    {...props}
  >
    <path d="M22.989 42.439H13.01L9 2h18z" />
    <path d="M50.989 42.439H41.01L37 2h18z" />
  </svg>
    </>
  )
}

export default DoubleQuote